export default __webpack_public_path__ + "static/media/washupLogo1.f250d503.png";